<template>
  <div class="container">
    <!-- 顶部导航 -->
    <ArticleNavbar @onShowShare="showShare=true" :article="article" :showAuthor="showAuthor"/>
    <!-- 滚动容器 -->
    <div class="scroll" ref="scrollDom" @scroll="scrollTop=$event.target.scrollTop">
      <div class="skeleton" v-if="loading">
        <van-skeleton style="margin-top:30px"  :row="2" />
        <van-skeleton style="margin-top:30px" title :row="10" />
      </div>
      <div class="main" v-else ref="main">
        <!-- 文章头部 -->
        <ArticleHeader ref="article-header" :article="article"/>
        <!-- 文章内容 -->
        <ArticleContent :article="article"/>
        <!-- 分隔 -->
        <div class="space"></div>
      </div>
      <div class="comment" v-show="!loading">
        <!-- 评论统计 -->
        <van-sticky offset-top="1.2267rem">
          <div class="comment-header van-hairline--bottom">
            <p>全部评论（{{article.comm_count||0}}）</p>
            <p>{{article.like_count||0}} 点赞</p>
          </div>
        </van-sticky>
        <!-- 评论列表 -->
        <ArticleComment @onShowReply="handlerShowReply" ref="commentList" />
      </div>
    </div>
    <!-- 底部区域 -->
    <ArticleFooter
      :article="article"
      @onScrollComment="scrollComment"
      @onShowShare="showShare=true"
      @onShowInput="showInput=true"
    />
    <!-- 分享组件 -->
    <ArticleShare v-model="showShare" />
    <!-- 输入组件 -->
    <ArticleInput @submit="submitCommit" title="评论文章" placeholder="说点什么~" v-model="showInput" />
    <!-- 回复组件 -->
    <ArticleReply @onShowInput="showInput=true" v-model="showReply" :article="article" :item="currReply"/>
  </div>
</template>
<script>
import ArticleNavbar from './components/article-navbar'
import ArticleHeader from './components/article-header'
import ArticleFooter from './components/article-footer'
import ArticleContent from './components/article-content'
import ArticleComment from './components/article-comment'
import ArticleShare from './components/article-share'
import ArticleInput from './components/article-input'
import ArticleReply from './components/article-reply'
import { getArticle, commentOrReply } from '@/api/article'
export default {
  name: 'ArticlePage',
  components: {
    ArticleNavbar,
    ArticleHeader,
    ArticleFooter,
    ArticleContent,
    ArticleComment,
    ArticleShare,
    ArticleInput,
    ArticleReply
  },
  data () {
    return {
      article: {
        art_id: '',
        comm_count: 0,
        like_count: 0
      },
      loading: true,
      scrollTop: 0,
      headerHeight: 0,
      // 分享
      showShare: false,
      // 滚动到评论
      scrollCommentFlag: false,
      // 输入
      showInput: false,
      // 回复
      showReply: false,
      currReply: {}
    }
  },
  computed: {
    showAuthor () {
      return this.scrollTop > this.headerHeight
    }
  },
  activated () {
    this.getArticleData()
  },
  methods: {
    handlerShowReply (item) {
      this.currReply = item
      this.showReply = true
    },
    async submitCommit (text) {
      console.log(1)
      try {
        this.$toast.loading()
        const data = await commentOrReply(this.article.art_id, text)
        this.$refs.commentList.list.unshift(data.new_obj)
        this.article.comm_count++
        this.$toast.success('评论成功')
        this.showInput = false
      } catch (e) {
        this.$toast.fail('评论失败')
      }
    },
    async getArticleData () {
      if (this.article.art_id.toString() === this.$route.params.id) {
        this.$refs.scrollDom.scrollTop = this.scrollTop
      } else {
        this.loading = true
        this.scrollTop = 0
        const data = await getArticle(this.$route.params.id)
        this.article = { ...this.article, ...data }
        this.loading = false
        this.$nextTick(() => {
          this.headerHeight = this.$refs['article-header'].$el.offsetHeight
        })
      }
    },
    scrollComment () {
      this.scrollCommentFlag = !this.scrollCommentFlag
      if (this.scrollCommentFlag) {
        this.$refs.scrollDom.scrollTop = this.$refs.main.offsetHeight
      } else {
        this.$refs.scrollDom.scrollTop = 0
      }
    }
  }
}
</script>
<style scoped lang="less">
.container {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .skeleton {
    flex: 1;
  }
  .scroll {
    flex: 1;
    overflow-y: auto;
    .main {
      .space {
        height: 12px;
        background: #F7F8FA;
      }
    }
    .comment-header {
      background: #fff;
      padding: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #000;
      p {
        &:first-child {
          font-size: 16px;
        }
        &:last-child {
          color: #A5A6AB;
        }
      }
    }
  }
}
</style>
